module.exports = __webpack_public_path__ + "img/header2.b14ad837.png";